import { StringUtil } from "./StringUtil";
import { FormulaStrings } from "./FormulaStrings";
var FUNC_PREFIX_SYS_LINK = "=SYS_LINK";
var FUNC_PREFIX_SYS_CELLIMAGE = "=SYS_CELLIMAGE(";
var FUNC_PREFIX_SYS_CONTAINERLINK = "=SYS_CONTAINERLINK(";
var FUNC_PARAMETER_COUNT = {
    LINK: 2,
    SHEETLINK: 2,
    CONTAINERLINK: 2,
    CELLIMAGE: 5
};
var SystemFormulaUtil = /** @class */ (function () {
    function SystemFormulaUtil() {
    }
    /**
     * This method is used to determine if a formula is a URL Hyperlink formula
     * @param {string} formulaDefinition
     * @return {boolean} true if formula refers to a url hyperlink, false if not
     */
    SystemFormulaUtil.isURLHyperlink = function (formulaDefinition) {
        return formulaDefinition.indexOf(FUNC_PREFIX_SYS_LINK) === 0;
    };
    /**
     * This method separates a formula string into a formula type and its parameters.
     * This method should work for all System Link-type formulas
     * This method is taken from app-core jscGridSystemFormula.parseFormula
     * @param {string} formulaDefinition
     * @return {SystemFormula | SystemFormulaError} system formula object if formula is valid, error if invalid
     */
    SystemFormulaUtil.parseSystemFormulaString = function (formulaDefinition) {
        var funcName = formulaDefinition.substring(5, formulaDefinition.indexOf("("));
        funcName = funcName.toUpperCase();
        var funcParmString = formulaDefinition.substring(formulaDefinition.indexOf("(") + 1, formulaDefinition.length - 1);
        var parmStringLength = funcParmString.length;
        var parmsArray = [];
        var parmBuf = [];
        var isInString = false;
        var isInEscape = false;
        var ch;
        for (var i = 0; i < parmStringLength; i++) {
            ch = funcParmString.charAt(i);
            // no inspection if in escape, simply accept character
            if (isInString) {
                if (isInEscape) {
                    isInEscape = false;
                    parmBuf.push(ch);
                }
                else if (ch == '"') {
                    isInString = false;
                }
                else if (ch == "\\") {
                    isInEscape = true;
                }
                else {
                    parmBuf.push(ch);
                }
            }
            else {
                if (ch == '"') {
                    isInString = true;
                }
                else if (ch == ",") {
                    if (parmBuf.length == 0) {
                        parmsArray.push(undefined);
                    }
                    else {
                        parmsArray.push(parmBuf.join(""));
                        parmBuf = [];
                    }
                }
                else {
                    parmBuf.push(ch);
                }
            }
        }
        if (parmBuf.length > 0) {
            parmsArray.push(parmBuf.join(""));
        }
        // check that formula has the correct number of parameters
        if (this.isValidFunctionName(funcName)) {
            var validNumberOfParms = FUNC_PARAMETER_COUNT[funcName];
            if (validNumberOfParms !== parmsArray.length) {
                return {
                    error: FormulaStrings.incorrectArgumentSet
                };
            }
        }
        else {
            return {
                error: FormulaStrings.unrecognizedFunction
            };
        }
        return { formulaDefinition: formulaDefinition, formulaParms: parmsArray, formulaName: funcName };
    };
    /**
     * This method takes a URL formula and converts it to HTML
     * @param {SystemFormula} URL formula
     * @return {string} HTML representation of the URL hyperlink
     */
    SystemFormulaUtil.convertURLFormulaToHTML = function (formula) {
        // obtain and validate text argument
        var argText = formula.formulaParms[0];
        if (argText == undefined) {
            argText = "";
        }
        // obtain and validate url argument
        var argUrl = formula.formulaParms[1];
        if (argUrl == undefined) {
            argUrl = "";
        }
        // deal with null argText and argUrl
        if (argText.length == 0 || argUrl.length == 0) {
            return argText;
        }
        // validate argUrl is a valid URL
        if (!StringUtil.isLink(argUrl)) {
            // TODO EURO-7726: log and return proper error
            return "Error with hyperlink";
        }
        // build the link HTML
        var htmlBuf = [];
        htmlBuf.push('<a href="');
        if (!/(^http|^sip)/i.test(argUrl)) {
            htmlBuf.push("http://");
        }
        htmlBuf.push(StringUtil.toHtml(argUrl));
        // link color must match lodestar-core's ctaLink
        htmlBuf.push("\" target=\"_blank\" style=\"text-decoration:underline; cursor:pointer; color:#0970be; white-space:inherit;\">");
        htmlBuf.push(StringUtil.toHtml(argText));
        htmlBuf.push("</a>");
        return htmlBuf.join("");
    };
    /**
     * Determine if a formula definition is a cell image formula.
     *
     * @param {string} formulaDefinition
     * @return {boolean} true if formula refers to a cell image, false if not
     */
    SystemFormulaUtil.isCellImageFormula = function (formulaDefinition) {
        return formulaDefinition.indexOf(FUNC_PREFIX_SYS_CELLIMAGE) === 0;
    };
    /**
     * Determine if a formula definition is a container link formula.
     *
     * @param {string} formulaDefinition
     * @return {boolean} true if formula refers to a container link, false if not
     */
    SystemFormulaUtil.isContainerLinkFormula = function (formulaDefinition) {
        return formulaDefinition.indexOf(FUNC_PREFIX_SYS_CONTAINERLINK) === 0;
    };
    /**
     * This method will parse the formula and return a CellImage if parameters are valid
     * or SystemFormulaError with error string if parameters are invalid
     *
     * Note: isCellImageFormula should have already been called to check that formula is correct
     * @param {string} formula
     * @return {CellImage | SystemFormulaError} cell image object if formula is valid, error if invalid
     */
    SystemFormulaUtil.parseImageFormula = function (formula) {
        var parsedFormula = SystemFormulaUtil.parseSystemFormulaString(formula);
        if (parsedFormula.error) {
            return parsedFormula;
        }
        else {
            parsedFormula = parsedFormula;
        }
        var formulaParameters = parsedFormula.formulaParms;
        // check for correct parameter types
        var IS_INTEGER_REGEX = /^\d+$/;
        if (!IS_INTEGER_REGEX.test(formulaParameters[2]) || !IS_INTEGER_REGEX.test(formulaParameters[3])) {
            return {
                error: FormulaStrings.numberExpected
            };
        }
        return {
            altText: formulaParameters[0],
            privateId: formulaParameters[1],
            originalHeight: Number(formulaParameters[2]),
            originalWidth: Number(formulaParameters[3]),
            fileName: formulaParameters[4]
        };
    };
    SystemFormulaUtil.isValidFunctionName = function (funcName) {
        return funcName in FUNC_PARAMETER_COUNT;
    };
    return SystemFormulaUtil;
}());
export { SystemFormulaUtil };
//# sourceMappingURL=SystemFormulaUtil.js.map